import { Injectable } from '@angular/core';
import { User } from '../models/auth.models';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {LoginModel} from "../models/login.model";
import { environment } from '../../environtment/environtment';

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    web_url = environment.web_url; // WEB
    api_url = environment.api_nestjs; // API
    user!: User;
    currentUserValue: any;

    constructor(
        private httpClient: HttpClient,
        private router: Router
    ) { }

    /**
     * Performs the auth
     * @param body
     */
    login(body: LoginModel): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        return this.httpClient.post(this.api_url + '/auth/login', body, {headers});
    }



    /**
     * Logout the user
     */
    logout() {
        // logout the user
        localStorage.clear();
        this.router.navigate(['/account/login']);
    }

    /**
     * Reset password
     * @param email email
     */
    // resetPassword(email: string) {
    //     return getFirebaseBackend()!.forgetPassword(email).then((response: any) => {
    //         const message = response.data;
    //         return message;
    //     });
    // }

}

